import { render } from "./disalysis_queue.vue?vue&type=template&id=5136de85&scoped=true"
import script from "./disalysis_queue.vue?vue&type=script&lang=js"
export * from "./disalysis_queue.vue?vue&type=script&lang=js"

import "./disalysis_queue.vue?vue&type=style&index=0&id=5136de85&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5136de85"]])

export default __exports__